import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core";
import Loadable from "react-loadable";
import Loading from "./components/Loading/Loading";
import xtheme from "./stylesheets/theme";

const Home = Loadable({
	loader: () => import("./pages/Home"),
	loading: Loading,
});
const CoatingsList = Loadable({
	loader: () => import("./pages/CoatingsList"),
	loading: Loading,
});
const CoatingsSection = Loadable({
	loader: () => import("./pages/CoatingsSection"),
	loading: Loading,
});
const Coating = Loadable({
	loader: () => import("./pages/Coating"),
	loading: Loading,
});
const CoatingWall = Loadable({
	loader: () => import("./pages/CoatingWall"),
	loading: Loading,
});
const CoatingFloor = Loadable({
	loader: () => import("./pages/CoatingFloor"),
	loading: Loading,
});
const PrivacyPolicy = Loadable({
	loader: () => import("./pages/PrivacyPolicy"),
	loading: Loading,
});
const Downloads = Loadable({
	loader: () => import("./pages/Downloads"),
	loading: Loading,
});
const SimulatorList = Loadable({
	loader: () => import("./pages/SimulatorList"),
	loading: Loading,
});
const SimulatorSection = Loadable({
	loader: () => import("./pages/SimulatorSection"),
	loading: Loading,
});
const Simulator = Loadable({
	loader: () => import("./pages/Simulator"),
	loading: Loading,
});
const SpecialSection = Loadable({
	loader: () => import("./pages/SpecialSection"),
	loading: Loading,
});
const Shops = Loadable({
	loader: () => import("./pages/Shops"),
	loading: Loading,
});
const About = Loadable({
	loader: () => import("./pages/About"),
	loading: Loading,
});
const Contact = Loadable({
	loader: () => import("./pages/Contact"),
	loading: Loading,
});
const Group = Loadable({
	loader: () => import("./pages/Group"),
	loading: Loading,
});
const Guide = Loadable({
	loader: () => import("./pages/Guide"),
	loading: Loading,
});
const Search = Loadable({
	loader: () => import("./pages/Search"),
	loading: Loading,
});
const NotFound = Loadable({
	loader: () => import("./pages/NotFound"),
	loading: Loading,
});
const IframePage = Loadable({
	loader: () => import("./pages/IframePage"),
	loading: Loading,
});
const Viewer3d = Loadable({
	loader: () => import("./pages/3dViewer"),
	loading: Loading,
});
const Roomvo = Loadable({
  loader: () => import("./pages/Roomvo"),
  loading: Loading,
});

const SimulaPointer = Loadable({
  loader: () => import("./pages/SimulaPointer"),
  loading: Loading,
});

const App = () => {
	return (
		<MuiThemeProvider theme={xtheme}>
			<Router>
				<Switch>
					<Route exact path="/" component={Home} />
					
					<Route exact path="/revestimentos" component={CoatingsSection} />
					<Route exact path="/revestimentos/:filters*" component={CoatingsSection} />
					<Route exact path="/revestimento/:slug" component={Coating} />
					<Route exact path="/visualizacao3d/produto/:productCode" component={Viewer3d} />
					<Route exact path="/tiles" render={(props) => <CoatingsList {...props} lg="en" />} />
					<Route exact path="/tiles/:filters*" render={(props) => <CoatingsSection {...props} lg="en" />} />
					<Route exact path="/tile/:slug" render={(props) => <Coating {...props} lg="en" />} />
					<Route exact path="/revestimientos" render={(props) => <CoatingsList {...props} lg="es" />} />
					<Route exact path="/revestimientos/:filters*" render={(props) => <CoatingsSection {...props} lg="es" />} />
					<Route exact path="/revestimiento/:slug" render={(props) => <Coating {...props} lg="es" />} />

					<Route exact path="/revestimento-para-parede" component={CoatingWall} />
					<Route exact path="/revestimento-para-piso" component={CoatingFloor} />

					<Route exact path="/politica-de-privacidade" component={PrivacyPolicy} />
					<Route exact path="/privacy-policy" render={(props) => <PrivacyPolicy {...props} lg="en" />} />
					<Route exact path="/politica-de-privacidad" render={(props) => <PrivacyPolicy {...props} lg="es" />} />

					<Route exact path="/downloads/:filters*" component={Downloads} />

					<Route exact path="/simulador-de-ambientes" component={SimulatorList} />
					<Route exact path="/simulador-de-ambientes/:environment" component={SimulatorSection} />
					<Route exact path="/simulador-de-ambientes/:environment/:group" component={Simulator} />
					<Route exact path="/environment-simulator" render={(props) => <SimulatorList {...props} lg="en" />} />
					<Route exact path="/environment-simulator/:environment" render={(props) => <SimulatorSection {...props} lg="en" />} />
					<Route exact path="/environment-simulator/:environment/:group" render={(props) => <Simulator {...props} lg="en" />} />
					<Route exact path="/ambientes-simulados" component={SimulatorList} />
					<Route exact path="/ambientes-simulados/:environment" component={SimulatorSection} />
					<Route exact path="/ambientes-simulados/:environment/:group" component={Simulator} />
					<Route exact path="/simulapointer" component={SimulaPointer} />
					<Route exact path="/especiais/:slug" component={SpecialSection} />
					<Route exact path="/specials/:slug" render={(props) => <SpecialSection {...props} lg="en" />} />
					<Route exact path="/especiales/:slug" render={(props) => <SpecialSection {...props} lg="es" />} />

					<Route exact path="/ondecomprar" component={Shops} />
					<Route exact path="/wheretobuy" render={(props) => <Shops {...props} lg="en" />} />
					<Route exact path="/dondecomprar" render={(props) => <Shops {...props} lg="es" />} />

					<Route exact path="/sobre-a-pointer" component={About} />
					<Route exact path="/about-pointer" render={(props) => <About {...props} lg="en" />} />
					<Route exact path="/acerca-de-pointer" render={(props) => <About {...props} lg="es" />} />

					<Route exact path="/contato" component={Contact} />
					<Route exact path="/customer-service" render={(props) => <Contact {...props} lg="en" />} />
					<Route exact path="/atencion" render={(props) => <Contact {...props} lg="es" />} />

					<Route exact path="/home-guide" component={Guide} />

					<Route exact path="/busca/:query?" component={Search} />
					<Route exact path="/search/:query?" render={(props) => <Search {...props} lg="en" />} />
					<Route exact path="/busqueda/:query?" render={(props) => <Search {...props} lg="es" />} />

					<Route exact path="/ondecomprar/produto/:query" render={(props) => <IframePage {...props} src="https://pointer.pertinhodemim.com/produto/" allow="geolocation" />} />

					<Route exact path="/ondecomprar/busca/:query" render={(props) => <IframePage {...props} src="https://pointer.pertinhodemim.com/busca?q=" />} />

					<Route exact path="/comprar/:query" render={(props) => <IframePage {...props} src="https://pointer.pertinhodemim.com/product/" postfix="?test=true" allow="geolocation" />} />
                    <Route exact path="/roomvo" component={Roomvo} />
                    <Route exact path="/simulapointer" component={SimulaPointer} />
					<Route component={NotFound} />
				</Switch>
			</Router>
		</MuiThemeProvider>
	);
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js